import script from "./confirm-letter-preview.vue?vue&type=script&lang=tsx&setup=true"
export * from "./confirm-letter-preview.vue?vue&type=script&lang=tsx&setup=true"

import "./confirm-letter-preview.vue?vue&type=style&index=0&id=f7c4a656&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7c4a656"]])

export default __exports__